import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import './Login.css'; // Create a CSS file for styling if you wish

const Register = () => {
  const [user, setUser] = useState({
    name: '',
    email: '',
    password: '',
    role: ''
  });
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setUser((prevUser) => ({ ...prevUser, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!user.name || !user.email || !user.password) {
      setError('Please fill out all required fields.');
      return;
    }

    try {
      const response = await axios.post(`${config.apiBaseUrl}/auth/register`, {
        name: user.name,
        email: user.email,
        password: user.password,
        role: user.role || 'user'
      });

      if (response.status === 201) {
        setSuccessMessage('Registration successful! You can now log in.');
        setError(null);
        // Redirect after a short delay or provide a link
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (err) {
      console.error('Error registering user:', err);
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Registration failed. Please try again.');
      }
    }
  };

  return (
    <div className="register-wrapper d-flex align-items-center auth px-0">
      <div className="row w-100 mx-0 justify-content-center">
        <div className="col-lg-4 mx-auto">
          <div className="auth-form-light text-left py-5 px-4 px-sm-5 rounded shadow-lg">
            <h3 className="text-center font-weight-bold mb-1">Create Your Account</h3>
            <p className="text-muted text-center mb-4">
              Start using AMS by filling in the details below
            </p>

            {/* Error Message */}
            {error && <div className="alert alert-danger text-center">{error}</div>}
            {/* Success Message */}
            {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}

            <form className="pt-3" onSubmit={handleSubmit}>
              {/* Name Field */}
              <div className="form-group">
                <label htmlFor="name">
                  <i className="ti-user text-primary mr-1"></i>Name
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={user.name}
                  onChange={handleInputChange}
                  placeholder="Enter your name"
                  required
                />
              </div>

              {/* Email Field */}
              <div className="form-group">
                <label htmlFor="email">
                  <i className="ti-email text-primary mr-1"></i>Email
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="email"
                  name="email"
                  value={user.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  required
                />
              </div>

              {/* Password Field */}
              <div className="form-group">
                <label htmlFor="password">
                  <i className="ti-lock text-primary mr-1"></i>Password
                </label>
                <input
                  type="password"
                  className="form-control form-control-sm"
                  id="password"
                  name="password"
                  value={user.password}
                  onChange={handleInputChange}
                  placeholder="Enter a strong password"
                  required
                />
              </div>

              {/* Role Field (Optional) */}
              <div className="form-group">
                <label htmlFor="role">
                  <i className="ti-id-badge text-primary mr-1"></i>Role (optional)
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="role"
                  name="role"
                  value={user.role}
                  onChange={handleInputChange}
                  placeholder="User, Admin, etc."
                />
              </div>

              {/* Submit Button */}
              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-primary btn-block btn-sm font-weight-medium auth-form-btn"
                >
                  <i className="ti-user"></i> Register
                </button>
              </div>

              {/* Login Redirect */}
              <div className="text-center mt-4 font-weight-light">
                Already have an account?{' '}
                <a href="/login" className="text-primary">
                  Login
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
